import { FC, useMemo, useState } from 'react';
import OverlappingDropdown from './OverlappingDropdown';
import {
  PDSelectDropdownBinocularPDOption,
  PDSelectDropdownEmptyState,
  PDSelectDropdownMonocularPDOption
} from './PDSelectDropdown';

export interface PDOption {
  id: string;
  binocular_dist_pd: string;
  left_height_multifocal: string;
  left_monocular_dist_pd: string;
  right_height_multifocal: string;
  right_monocular_dist_pd: string;
  created_at?: string;
}

const isMonocular = (option: PDOption) =>
  option.left_monocular_dist_pd || option.right_monocular_dist_pd;

interface UIPDSelectProps {
  options: PDOption[];
  value?: string;
  // eslint-disable-next-line no-unused-vars
  onChanged?: (value: string) => void;
  placeholder: string;
}

const UIPDSelect: FC<UIPDSelectProps> = ({
  options,
  value,
  onChanged,
  placeholder = 'Select PD'
}) => {
  const [isActive, setIsActive] = useState(false);

  const selectedPD = useMemo(
    () => options.find((option) => option.id === value),
    [options, value]
  );

  var newOptions: any = [];
  options.map((option: any) => {
    var check = newOptions.filter((newOption: any) => {
      if (option.binocular_dist_pd == null &&
        newOption.binocular_dist_pd == null &&
        newOption.left_monocular_dist_pd == option.left_monocular_dist_pd &&
        newOption.left_height_multifocal == option.left_height_multifocal &&
        newOption.right_monocular_dist_pd == option.right_monocular_dist_pd &&
        newOption.right_height_multifocal == option.right_height_multifocal
      ) {
        return newOption;
      }

      if (option.binocular_dist_pd == newOption.binocular_dist_pd && option.binocular_dist_pd !== null) {
        return newOption;
      }
    }).length;
    if (check == 0) {
      newOptions.push(option);
    }
  });

  var binoculars: any = [];
  var monoculars: any = [];
  var binocularWithHeight: any = [];


  newOptions.map((newOption: any) => {
    if (newOption.right_monocular_dist_pd && newOption.right_height_multifocal == null) {
      binoculars.push(newOption);
    } else if (newOption.right_monocular_dist_pd && newOption.right_height_multifocal != null) {
      binocularWithHeight.push(newOption);
    } else {
      monoculars.push(newOption);
    }
  })

  options = [...monoculars, ...binocularWithHeight, ...binoculars].sort((a: any, b: any) => {
		if (a.created_at > b.created_at) return -1;
		if (a.created_at < b.created_at) return 1;
		return 0;
	});

  return (
    <OverlappingDropdown
      active={isActive}
      updateActiveState={setIsActive}
      value={
        selectedPD?.binocular_dist_pd || selectedPD?.right_monocular_dist_pd ? (
          isMonocular(selectedPD) ? (
            <PDSelectDropdownMonocularPDOption
              option={{
                pd: selectedPD.binocular_dist_pd,
                right: selectedPD.right_monocular_dist_pd,
                rightHeight: selectedPD.right_height_multifocal,
                left: selectedPD.left_monocular_dist_pd,
                leftHeight: selectedPD.left_height_multifocal,
                created_at: selectedPD.created_at
              }}
            />
          ) : (
            <PDSelectDropdownBinocularPDOption
              option={{
                pd: selectedPD.binocular_dist_pd,
                created_at: selectedPD.created_at
              }}
            />
          )
        ) : undefined
      }
      placeholder={placeholder}>
      {!options.length && <PDSelectDropdownEmptyState />}
      {options.map((option, index) => (
        <div
          className="group border-b border-brand-grey500 text-brand-black25 transition-colors first:mt-[-12px] last:border-none sm:hover:text-brand-orange"
          key={option.id + '_' + index}
          onClick={() => {
            onChanged?.(option.id);
            setIsActive(false);
          }}>
          {isMonocular(option) ? (
            <PDSelectDropdownMonocularPDOption
              option={{
                pd: option.binocular_dist_pd,
                right: option.right_monocular_dist_pd,
                rightHeight: option.right_height_multifocal,
                left: option.left_monocular_dist_pd,
                leftHeight: option.left_height_multifocal,
                created_at: option.created_at
              }}
            />
          ) : (
            <PDSelectDropdownBinocularPDOption
              option={{
                pd: option.binocular_dist_pd,
                created_at: option.created_at
              }}
            />
          )}
        </div>
      ))}
    </OverlappingDropdown>
  );
};

export default UIPDSelect;
